<template>
  <v-slide-y-transition>
    <v-row class="mr-1 ml-1" v-show="showToastMessage">
      <v-col cols="12">
        <v-alert :color="toastType" dense>
          <template v-slot:prepend>
            <v-icon v-if="toastType == 'green'" color="white" class="mr-2"
              >mdi-check</v-icon
            >
            <v-icon v-if="toastType == 'secondary'" color="white" class="mr-2"
              >mdi-alert</v-icon
            >
          </template>
          {{ toastMessage }}
        </v-alert>
      </v-col>
    </v-row>
  </v-slide-y-transition>
</template>
<script lang="ts">
import { defineComponent } from 'vue'
import { mapGetters, mapMutations } from 'vuex'
export default defineComponent({
  name: 'ToastMessage',
  data() {
    return {}
  },
  computed: {
    ...mapGetters('ToastMessage', [
      'showToastMessage',
      'toastType',
      'toastMessage',
    ]),
  },
  watch: {
    toastType() {
      if (this.toastType == 'green') {
        setTimeout(() => {
          if (this.toastType !== 'red') {
            this.clearToast()
          }
        }, 3500)
      } else if (this.toastType == 'red') {
        setTimeout(() => {
          this.clearToast()
        }, 3500)
      }
    },
  },
  methods: {
    ...mapMutations('ToastMessage', ['clearToast']),
    closeToast() {
      this.clearToast()
    },
  },
})
</script>
